// extracted by mini-css-extract-plugin
module.exports = {"container":"PrivacyPolicy_container__24g8S","header":"PrivacyPolicy_header__q12sr","header__item":"PrivacyPolicy_header__item__wrk43"};